<template>
  <div class="container">
    <h4 class="card-title">{{catalog.name}}</h4>
    <div class="row">
      <div class="col">
        <div class="col-md-auto">
          <swiper :options="swiperOption" class="swiper-box" >
            <swiper-slide class="swiper-item" v-for="item in fetchPromotions" :key="item.index">
              <img :src="item" width="560px"/>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="col" style="background-color: white;">
          <tree-menu
            :label="catalog.name"
            :nodes="catalog.categories"
            :offers="this.first_offers"
            :category="this.first_category"
            :depth="0">
          </tree-menu>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="col">
            <h4>Label</h4>
            <table class="table table-bordered table-striped table-condensed" style="background-color: white;">
              <tbody>
                <tr>
                  <td><i class="icon-ghost"></i></td><td>Hidden</td>
                </tr>
                <tr>
                  <td><i class="icon-settings"></i></td><td>Manage</td>
                </tr>
                <tr>
                  <td><i class="icon-rocket"></i></td><td>in Suggestions area</td>
                </tr>
                <tr>
                  <td><i class="icon-grid"></i></td><td>has Previews</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col">
            <h4>Catalog Info</h4>
            <table class="table table-bordered table-striped table-condensed" style="background-color: white;">
              <tbody>
                <tr>
                  <td class="font-weight-bold">Trials</td><td>{{catalog.trials}}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Promotions</td><td>{{catalog.promotion_window_size}}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Creation</td><td>{{catalog.created_at | moment('LL')}}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">App</td><td>{{catalog.app_catalog.uid}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="w-100"></div>
          <div class="col">
            <h4>Startup Offer</h4>
            <table style="background-color: white;" class="table table-bordered table-striped table-condensed table-sm" v-if="catalog.startup_offers.length > 0">
              <tr v-for="startup in catalog.startup_offers">
                <td>
                  <product-offer-icon v-bind:icon="startup.product_offer.icon" width="36px"></product-offer-icon>
                </td>
                <td>
                  <span class="font-weight-bold">{{startup.product_offer_name}}</span></br>
                  <span class="card-subtitle mb-2 text-muted">{{startup.product_offer.codename}}</span>
                </td>
                <td>
                  <span v-for="version in getUniqueVersions(startup.versions)" class="badge badge-pill version">
                    {{version}}
                  </span>
                </td>
              </tr>
            </table>
          </div>
          <div class="w-100"></div>
          <div class="col">
            <h4>Bundle Offer</h4>
            <table style="background-color: white;" class="table table-bordered table-striped table-condensed table-sm" v-if="catalog.startup_offers.length > 0">
              <tr v-for="bundle in catalog.bundle_offers">
                <td>
                  <product-offer-icon v-bind:icon="bundle.product_offer.icon" width="36px"></product-offer-icon>
                </td>
                <td>
                  <span class="font-weight-bold">{{bundle.name}}</span></br>
                  <span class="card-subtitle mb-2 text-muted">{{bundle.product_offer.codename}}</span>
                </td>
                <td>
                  <span v-for="version in getUniqueVersions(bundle.versions)" class="badge badge-pill version">
                    {{version}}
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .swiper-container {
    width: 560px;
  }
  .icon-ghost {
    color: #039BE5;
    font-weight: bold;
  }
  .icon-settings {
    color: #43A047;
    font-weight: bold;
  }
  .icon-rocket {
    color: #F57C00;
    font-weight: bold;
  }
  .icon-grid {
    color: #D81B60;
    font-weight: bold;
  }
  .version {
    margin-right: 1px;
    background-color: #03A9F4;
  }
</style>

<script>
import catalogs from 'services/catalogs'
import TreeMenu from 'components/TreeMenu'
import ProductOfferIcon from 'components/ProductOfferIcon'
import ProductOfferItem from 'components/ProductOfferItem'

export default {
  name: 'catalog',
  created () {
    this.getCatalog()
  },
  data () {
    return {
      first_offers: [],
      first_category: [],
      catalog: {},
      swiperOption: {
        grabCursor: true,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    fetchPromotions () {
      return this.catalog.promotions.map(function (promotion) {
        return promotion.banner
      })
    }
  },
  components: {
    TreeMenu,
    ProductOfferIcon,
    ProductOfferItem
  },
  methods: {
    getCatalog () {
      catalogs.get(this, this.$route.params.id)
    },
    getUniqueVersions (versions) {
      var unique = versions.map(v => v.split('.', 2).join('.'))
      return Array.from(new Set(unique))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/catalogs/CatalogDevops.vue